import { useQueryClient } from '@tanstack/react-query'
import { createHouseConsignmentDraft } from '../api/createHouseConsignmentDraft'
import { fromHouseConsignmentDetails, toHouseConsignmentCreateDraft } from '../models/mapper'
import { HouseConsignment, HouseConsignmentDetails } from '../models/types'
import { QueryKeys } from '../../../key-registry'

function useCreateHouseConsignment(consignmentId: number) {
  const queryClient = useQueryClient()

  const saveHouseConsignmentDraft = async (sequenceNumber: number): Promise<HouseConsignmentDetails> => {
    const savedHouseConsignment = await createHouseConsignmentDraft(
      toHouseConsignmentCreateDraft(consignmentId, sequenceNumber),
    )
    if (!savedHouseConsignment?.id) throw new Error('Missing house consignment ID')

    queryClient.setQueryData<HouseConsignment[]>(QueryKeys.houseConsignment.all(consignmentId), (prev) => (prev
      ? [...prev, fromHouseConsignmentDetails(savedHouseConsignment, 0)] : prev))

    return savedHouseConsignment
  }

  return {
    saveHouseConsignmentDraft,
  }
}

export default useCreateHouseConsignment
